import { render, staticRenderFns } from "./IframeTaquilla.vue?vue&type=template&id=5bb02f50&"
import script from "./IframeTaquilla.vue?vue&type=script&lang=js&"
export * from "./IframeTaquilla.vue?vue&type=script&lang=js&"
import style0 from "./IframeTaquilla.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports